import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LandingComponent } from './landing/landing.component';
import { LanguageComponent } from './language/language.component';
import { VideoRecordingComponent } from './video-recording/video-recording.component';
import { VerificationComponent } from './verification/verification.component';
import { PivcCompleteComponent } from './pivc-complete/pivc-complete.component';
import { LinkExpireComponent } from './link-expire/link-expire.component';
import { ContactUsComponent } from './contact-us/contact-us.component';


const routes: Routes = [
    {path: '', component: LandingComponent},
    {path: 'language', component: LanguageComponent},
    {path: 'video-recording', component: VideoRecordingComponent},
    {path: 'verification', component: VerificationComponent},
    {path: 'pivc-complete', component: PivcCompleteComponent},
    {path: 'link-expire', component: LinkExpireComponent},
    {path: 'contact-us', component: ContactUsComponent}


];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
